export enum StatoFatturazioneIntervento {
  'NON FATTURABILE',
  'DA FATTURARE',
  'FATTURATO',
}
